import { __awaiter } from "tslib";
import { Chart } from "chart.js";
import { fetchDashboardData, getCanvasContext, q } from "../utils.js";
import { hexColorsGradient } from "../colors.js";
function run() {
    $(() => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            let m = moment();
            const { from, to } = JSON.parse($('#fromToWeeks').text());
            const $weeks = $('#from-weeks,#to-weeks');
            const $from = $weeks.eq(0);
            const $to = $weeks.eq(1);
            const arr = [];
            for (let i = 0; i <= 52; i++) {
                if (i === 0) {
                    arr.push(`<option value="${i}">Deze Week</option>`);
                }
                else {
                    arr.push(`<option value="${i}">${m.format('[Week] w, YYYY')}</option>`);
                }
                m = m.subtract(1, 'weeks');
            }
            $weeks.html(arr.reverse().join(''));
            $from.find('option:last-child').remove();
            // @ts-ignore
            const search = Object.fromEntries([...new URLSearchParams(location.search)]);
            $from.val((_a = from !== null && from !== void 0 ? from : search.from) !== null && _a !== void 0 ? _a : 2);
            $to.val((_b = to !== null && to !== void 0 ? to : search.to) !== null && _b !== void 0 ? _b : 0);
            $weeks.on('change', (e) => {
                location.search = `?from=${$from.val()}&to=${$to.val()}`;
            });
            $(window).on('resize', () => {
                const newHeight = (window.innerHeight - $('#main .kpi-block .kpi-body').eq(0).offset().top) / 2 - 38;
                $('.kpi-body').css('height', Math.min(window.innerWidth, newHeight));
            }).trigger('resize');
            const { enlistmentData, searchPointsData, enlistmentRatio } = yield fetchDashboardData();
            loadEnlistmentRatioChart('enlistment-ratio-chart', enlistmentRatio);
            loadPositionsWeeklyChart('timeline', enlistmentData);
            loadEnlistmentsWeeklyChart('enlistment-chart', enlistmentData);
            loadSearchPointsChart('searchpoints-chart', searchPointsData === null || searchPointsData === void 0 ? void 0 : searchPointsData.weeklySearchPoints);
        }
        catch (err) {
            console.error(err);
            modalService.error(err);
        }
    }));
}
function loadEnlistmentRatioChart(id, chartData = []) {
    if (charts.hasOwnProperty(id)) {
        charts[id].destroy();
    }
    const isLotingTypes = [null, 0, 1];
    isLotingTypes.map((v) => {
        if (!chartData.find(d => d.is_loting === v)) {
            chartData.push({ is_loting: v, amount_of_enlistments: 0 });
        }
    });
    chartData = chartData.sort((a, b) => (a.is_loting === null ? -1 : a.is_loting) - (b.is_loting === null ? -1 : b.is_loting));
    const total = chartData.map(d => d.amount_of_enlistments).reduce((a, b) => a + b, 0);
    chartData = chartData.map(d => {
        d.perc = (d.amount_of_enlistments * 100 / total).toFixed(2);
        return d;
    });
    const colors = ['#cccccc', '#b97f1a', '#f79319'];
    const canvas = q(id);
    const ctx = getCanvasContext(canvas);
    const chart = new Chart(ctx, {
        type: 'pie',
        data: {
            labels: ['Onbekend', 'Regulier', 'Loting'],
            datasets: [{
                    label: 'Percentage',
                    data: chartData.map(d => d.perc),
                    // backgroundColor: colors,
                    // borderColor: colors,
                    // borderWidth: 3,
                }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: true,
                    position: "bottom",
                },
                tooltip: {
                    callbacks: {
                        title(tooltipItems) {
                            return '';
                        },
                        label(tooltipItem) {
                            return ' ' + tooltipItem.label + ': ' + tooltipItem.formattedValue + '%';
                        },
                    }
                }
            },
        }
    });
    charts[id] = chart;
    return chart;
}
function loadPositionsWeeklyChart(id, chartData = []) {
    if (charts.hasOwnProperty(id)) {
        charts[id].destroy();
    }
    const [color1, color2, color3] = ['#f8af0c', '#ff4141', '#ad0000', '#ff005e']; // hexColors()
    const canvas = q(id);
    const ctx = getCanvasContext(canvas);
    const chart = new Chart(ctx, {
        type: 'line',
        data: {
            labels: chartData.map((d) => {
                return d.date;
            }),
            datasets: [{
                    label: 'Beste Positie',
                    data: chartData.map(d => d.min_user_position),
                    backgroundColor: color1,
                    borderColor: color1,
                    borderWidth: 3,
                    pointStyle: 'circle',
                    pointRadius: 3,
                    pointHoverRadius: 6,
                    spanGaps: true,
                }, {
                    label: 'Gemiddelde Positie',
                    data: chartData.map(d => d.avg_user_position),
                    backgroundColor: color2,
                    borderColor: color2,
                    borderWidth: 3,
                    pointStyle: 'circle',
                    pointRadius: 3,
                    pointHoverRadius: 6,
                    spanGaps: true
                }, {
                    label: 'Slechtste Positie',
                    data: chartData.map(d => d.max_user_position),
                    backgroundColor: color3,
                    borderColor: color3,
                    borderWidth: 3,
                    pointStyle: 'circle',
                    pointRadius: 3,
                    pointHoverRadius: 6,
                    spanGaps: true
                }, /*{
                    label: 'Aantal Reacties',
                    data: chartData.map(d => d.amount_of_enlistments),
                    backgroundColor: ['#000000'],
                    borderColor: ['#000000'],
                    type: 'bar'
                }*/
            ]
        },
        options: {
            // animation: {
            // 	duration: 300,
            // },
            spanGaps: true,
            responsive: true,
            maintainAspectRatio: false,
            // animation: getAnimation(chartData, 400),
            plugins: {
                legend: {
                    display: true,
                    position: "bottom",
                },
                tooltip: {
                    mode: 'x',
                    position: 'nearest',
                    callbacks: {
                        title: (opt) => {
                            return opt[0].label.replace(' ', ' Week ');
                            // const d = new Date(opt[0].parsed.x)
                            // return moment(d).format('YYYY MMM DD')
                        },
                    }
                }
            },
        }
    });
    charts[id] = chart;
    return chart;
}
function loadEnlistmentsWeeklyChart(id, chartData = []) {
    if (charts.hasOwnProperty(id)) {
        charts[id].destroy();
    }
    chartData = chartData.map(d => {
        d.dateTime = new Date(d.date).getTime();
        return d;
    });
    // amount_of_enlistments
    const canvas = q(id);
    const ctx = getCanvasContext(canvas);
    const gradientColors = hexColorsGradient(ctx, { shift: 3, height: canvas.clientHeight });
    // const colors = hexColors(3)
    const chart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: chartData.map((d) => {
                return d.date; // moment(d.date.replace(/\w/g, '-') + '-01').format('YYYY MMM')
                // const yyyymmdd = d.date.substr(0, d.date.indexOf('T'))
                // return yyyymmdd
            }),
            datasets: [{
                    label: 'Aantal Reacties',
                    data: chartData.map(d => d.amount_of_enlistments),
                    borderWidth: 1,
                    backgroundColor: gradientColors,
                    borderColor: gradientColors,
                }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    mode: 'x',
                    position: 'nearest',
                    callbacks: {
                        title: (opt) => {
                            return opt[0].label.replace(' ', ' Week ');
                            // return moment(opt[0].parsed.x + '-01').format('YYYY MMM')
                            // const d = new Date(opt[0].parsed.x)
                            // return moment(d).format('YYYY MMM DD')
                        },
                    }
                }
            },
        }
    });
    charts[id] = chart;
    return chart;
}
function loadSearchPointsChart(id, chartData = []) {
    if (charts.hasOwnProperty(id)) {
        charts[id].destroy();
    }
    const canvas = q(id);
    const ctx = getCanvasContext(canvas);
    const [color1, color2, color3, _, color4] = hexColorsGradient(ctx, { height: canvas.clientHeight });
    const chart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: chartData.map((d) => {
                return d.yyyymm;
            }),
            datasets: [{
                    label: 'Wacht Punten',
                    data: chartData.map(d => d.waitPoints),
                    backgroundColor: color1,
                    // borderColor: color1,
                    // borderWidth: 3,
                    // pointStyle: 'circle',
                }, {
                    label: 'Zoek Punten',
                    data: chartData.map(d => d.points),
                    backgroundColor: color2,
                    borderColor: color2,
                    // borderWidth: 3,
                    // pointStyle: 'circle',
                }, {
                    label: 'Start Punten',
                    data: chartData.map(d => d.startPoints),
                    backgroundColor: color3,
                    borderColor: color3,
                    // borderWidth: 3,
                    // pointStyle: 'circle',
                }, {
                    label: 'Situatie Punten',
                    data: chartData.map(d => d.situationPoints),
                    backgroundColor: color4,
                    borderColor: color4,
                    // borderWidth: 3,
                    // pointStyle: 'circle',
                }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: { stacked: true },
                y: { stacked: true },
            },
            plugins: {
                legend: {
                    display: true,
                    position: "bottom",
                },
                tooltip: {
                    mode: 'x',
                    callbacks: {
                        title: (opt) => {
                            return opt[0].label;
                        },
                        label: (tooltipItem) => {
                            const { datasets } = tooltipItem.chart.data;
                            var corporation = datasets[tooltipItem.datasetIndex].label;
                            var valor = datasets[tooltipItem.datasetIndex].data[tooltipItem.dataIndex];
                            // Loop through all datasets to get the actual total of the index
                            var total = 0;
                            for (var i = 0; i < datasets.length; i++)
                                total += Number(datasets[i].data[tooltipItem.dataIndex]);
                            // If it is not the last dataset, you display it as you usually do
                            if (tooltipItem.datasetIndex != datasets.length - 1) {
                                return corporation + ": " + Number(valor).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                            }
                            else { // .. else, you display the dataset and the total, using an array
                                return [
                                    corporation + ": " + Number(valor).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                                    "Totaal: " + Number(total).toFixed(2)
                                ];
                            }
                        }
                    }
                }
            },
        }
    });
    charts[id] = chart;
    return chart;
}
export const page_dashboard = {
    requiresAuth: true,
    run: run,
};
//# sourceMappingURL=dashboard.js.map